import React, { Component } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import uuid from "react-native-uuid";
import { Toastr } from "@revvsales/components";

import { readDataFromLocalStorage } from "../../utils/globalUtils";
import NotesActions from "../../actions/NotesActions";
import SharedDocumentActions from "../../actions/SharedDocumentActions";
import NotesHeader from "./NotesHeader";
import NotesThread from "./NotesThread";
import { emptyNote, isNewNoteOpen } from "./utils";
import {
  acceptRejectSectionChanges,
  updateDocumentClickedComponentID,
} from "../../actions/DocumentActions";
import EditorActions from "../../actions/EditorActions";

import { createHighlightNotes } from "../../utils/draftUtils";
// import { updateCellData } from "../RevvTable/utils";
import { getComponentEditorData } from "../../utils/components";

// Internal Imports
import { AmplitudeUtils, DocumentUtils } from "../../utils";
import { EVENTS } from "../../constants";
import { NOTES_STRINGS } from "../../stringConstants/index";

const {
  getNotesByDocID,
  addNote,
  updateNotes,
  getAllDocNotes,
  postNewNote,
  editNote,
  deleteNote,
  uploadAttachment,
  fetchAllUsersForMentions,
} = NotesActions;

const { getUpdatedParentComponent } = DocumentUtils;
const { createSharedDocumentNote } = SharedDocumentActions;
const { initEditorState } = EditorActions;

class Notes extends Component {
  state = {
    activeNoteID: null,
  };

  // Rewrite
  // move it fetch user call from here to somewhere else
  componentDidMount() {
    const { isSharedDocument } = this.props;
    if (!isSharedDocument) {
      if (this.props.mentionUsers.length === 0) {
        this.props.fetchAllUsersForMentions();
      }
    }
  }

  _validateNoOpenNotes = () => {
    if (isNewNoteOpen(this.props.documentNotes) || this.state.activeNoteID) {
      Toastr.showToastr({
        type: "warning",
        message: NOTES_STRINGS.OPEN_NOTES_ERROR,
        timeout: 6000,
      });
      return false;
    }
    return true;
  };

  _openNoteEditor = noteID => {
    if (this._validateNoOpenNotes()) {
      this.setState({
        activeNoteID: noteID,
      });
    }
  };

  _createNewNote = () => {
    if (this._validateNoOpenNotes()) {
      const { docID, addNewNote } = this.props;
      const note = emptyNote(docID, null);
      addNewNote(note).then(() => {
        setTimeout(() => {
          this._scrollToNewNote();
        }, 100);
      });
      this._scrollToNewNote();
    }
  };

  _scrollToNewNote = () => {
    const newNote = document.getElementById("new-note-with-null-id");
    if (newNote !== null) {
      newNote.scrollIntoView({
        behavior: "smooth",
      });
      // this._removeActiveComponents();
      newNote.classList.add("new-note-border");
    }
  };

  _addReply = baseID => {
    if (this._validateNoOpenNotes()) {
      const { updateNotesList, documentNotes, docID } = this.props;
      const note = emptyNote(docID, baseID);
      const updatedNotes = documentNotes.map(noteThread => {
        if (noteThread.id === baseID) {
          const replies = noteThread.replies || [];
          noteThread.replies = [...replies, note];
        }
        return noteThread;
      });
      updateNotesList(updatedNotes);
    }
  };

  _discardNote = note => {
    const { documentNotes, updateNotesList } = this.props;
    const { activeNoteID } = this.state;
    let updatedNotes;
    if (note.id === null) {
      if (note.base_comment_id === null) {
        updatedNotes = documentNotes.filter(noteThread => noteThread !== note);
      } else {
        const baseID = note.base_comment_id;
        updatedNotes = documentNotes.map(noteThread => {
          if (noteThread.id === baseID) {
            return {
              ...noteThread,
              replies: noteThread.replies.filter(reply => reply.id !== null),
            };
          }
          return noteThread;
        });
      }
      updateNotesList(updatedNotes);
    } else if (activeNoteID === note.id) {
      this.setState({
        activeNoteID: null,
      });
    }
    if (note.anchor && note.anchor.action === "HIGHLIGHT" && note.id === null) {
      const { component, removeHighlightSelection } = note;
      removeHighlightSelection(component.id);
    }
  };

  _updateNoteList = (note, newNote) => {
    const { documentNotes, updateNotesList } = this.props;
    let updatedNotes;
    if (note.base_comment_id === null) {
      updatedNotes = documentNotes.map(noteThread => {
        if (noteThread.id === note.id && noteThread.anchor === note.anchor) {
          return newNote;
        }
        return noteThread;
      });
    } else {
      updatedNotes = documentNotes.map(noteThread => {
        if (noteThread.id === note.base_comment_id) {
          const updatedThread = {
            ...noteThread,
            replies: noteThread.replies.map(noteItem => {
              if (noteItem.id === note.id && noteItem.anchor === note.anchor) {
                return newNote;
              }
              return noteItem;
            }),
          };
          return updatedThread;
        }
        return noteThread;
      });
    }
    updateNotesList(updatedNotes);
  };

  _updateSectionPostNoteAddion = note => {
    const { updateSection, editorState, activeComponentMeta } = note;

    const { updatedEditorState, key } = createHighlightNotes(editorState);
    const editorData = getComponentEditorData(
      this.props.components,
      activeComponentMeta,
    );
    const updatedSection = getUpdatedParentComponent(
      this.props.components,
      activeComponentMeta,
      {
        ...editorData,
        currentContent: updatedEditorState.getCurrentContent(),
      },
    );
    const clickedComponentID =
      updatedSection.type === "Table"
        ? this.props.tableCellId
        : updatedSection.id;
    this.props.updateDocumentClickedComponentID(
      clickedComponentID,
      true,
      updatedSection.type,
    );
    this.props.initEditorState(updatedEditorState, updatedSection);

    updateSection(updatedSection);
    // last created entity key
    note.anchor.id = key;
    delete note.component;
    delete note.updateSection;
    delete note.editorState;
  };

  _saveNote = saveNote => {
    let note = {
      ...saveNote,
    };

    if (
      "draftJSNote" in note.content &&
      Array.isArray(note.content.draftJSNote)
    ) {
      const message = note.content.draftJSNote
        .map(df => df.blocks.map(block => block.text).join("\n"))
        .join("\n");
      note.content = {
        ...note.content,
        message,
      };
    }

    if (note.id === null) {
      const { createNote, isSharedDocument } = this.props;
      // check if it is highlighted notes. Then first update section data
      if (note.anchor && note.anchor.action === "HIGHLIGHT") {
        this._updateSectionPostNoteAddion(note);
      }
      let postNote = createNote;
      if (isSharedDocument) {
        const { docID, sharingHash } = this.props;
        postNote = this.props.createSharedDocumentNote;
        note = {
          note,
          docID,
          sharingHash,
        };
      }
      postNote(note).then(response => {
        const { status, docID, docType } = this.props;
        const newNote = {
          ...response.Comment,
          replies: note.replies,
        };

        if (isSharedDocument) {
          this._updateNoteList(note.note, newNote);
        } else {
          this._updateNoteList(note, newNote);
        }
        // Implementing amplitude for comment adding
        AmplitudeUtils.amplitudeLogEvent(EVENTS.EVENT_NAMES.COMMENT_ADDED, {
          // Tagged: JSON.stringify(newNote.anchor) !== "{}",
          Tagged: Object.keys(newNote.anchor).length > 0,
          Mention: newNote.mentions && newNote.mentions.length > 0,
          Reply: newNote.base_comment_id !== null,
          Status: status,
          Document_id: docID,
          Document_type: docType,
        });
      });
    } else {
      const { editNoteByID } = this.props;
      editNoteByID(note).then(response => {
        const newNote = {
          ...response.Comment,
          replies: note.replies,
        };
        this._updateNoteList(note, newNote);
        if (this.state.activeNoteID === note.id) {
          this.setState({
            activeNoteID: null,
          });
        }
      });
    }
  };

  _deleteNote = note => {
    const { deleteNoteByID } = this.props;
    deleteNoteByID(note.id).then(response => {
      console.debug(response);
      const { documentNotes, updateNotesList } = this.props;
      let updatedNotes;
      if (note.base_comment_id === null) {
        updatedNotes = documentNotes.filter(
          noteThread => noteThread.id !== note.id,
        );
      } else {
        updatedNotes = documentNotes.map(noteThread => {
          if (noteThread.id === note.base_comment_id) {
            const updatedNote = {
              ...noteThread,
              replies: noteThread.replies.filter(
                noteItem => noteItem.id !== note.id,
              ),
            };
            return updatedNote;
          }
          return noteThread;
        });
      }
      updateNotesList(updatedNotes);
    });
  };

  _acceptRejectChanges = (note, accept) => {
    const { editNoteByID } = this.props;
    const { anchor } = note;
    // check accepted or rejected state
    const updatedNote = {
      ...note,
      comment_status: accept ? "Accepted" : "Rejected",
    };
    editNoteByID(updatedNote)
      .then(response => {
        const newNote = {
          ...response.Comment,
        };
        this._updateNoteList(updatedNote, newNote);

        if (
          (anchor.action === "DELETED" && accept) ||
          (anchor.action === "INSERTED" && !accept)
        ) {
          this.props.acceptRejectSectionChanges(
            anchor.component_id,
            anchor.id,
            false,
            "DOCUMENT",
          );
        } else {
          this.props.acceptRejectSectionChanges(
            anchor.component_id,
            anchor.id,
            true,
            "DOCUMENT",
          );
        }
      })
      .catch(error => {
        this._updateNoteList(note, note);
        Toastr.showToastr({
          type: "failure",
          message:
            error && error.response && error.response.status === 403
              ? "You are not allowed accept/reject Notes for this document"
              : "Unable to accept/reject. Please try after some time.",
          timeout: 6000,
        });
      });
    note.comment_status = "OPEN";
  };

  _emptyNotesView = () => (
    <div className="notes-empty-state">
      <span className="addproduct-info">
        {" "}
        {NOTES_STRINGS.EMPTY_NOTES_STRING}
      </span>{" "}
      <div className="notes-empty-icon">
        <i className="notes-empty-icon-front">
          <FontAwesomeIcon icon={["fas", "sticky-note"]} />{" "}
        </i>{" "}
        <i className="notes-empty-icon-back">
          <FontAwesomeIcon icon={["fas", "sticky-note"]} />{" "}
        </i>{" "}
      </div>{" "}
    </div>
  );

  _notesThreadView = () => {
    const {
      documentNotes,
      uploadNoteAttachment,
      isSharedDocument,
    } = this.props;
    const { activeNoteID } = this.state;
    const author = readDataFromLocalStorage("revvsalesUser");
    if (!Array.isArray(documentNotes) || documentNotes.length === 0) {
      return this._emptyNotesView();
    }
    return documentNotes.map(notesThread => (
      <NotesThread
        key={uuid.v4()}
        author={author}
        noteThread={notesThread}
        openNoteEditor={this._openNoteEditor}
        activeNoteID={activeNoteID}
        discardNote={this._discardNote}
        addReply={this._addReply}
        saveNote={this._saveNote}
        deleteNote={this._deleteNote}
        uploadAttachment={uploadNoteAttachment}
        acceptRejectChanges={this._acceptRejectChanges}
        isSharedDocument={isSharedDocument}
      />
    ));
  };

  render() {
    return (
      <div className="context-notes  animated fadeinright">
        <NotesHeader addNote={this._createNewNote} />{" "}
        <div className="notes-container">
          {" "}
          <div className="content-scroll">{this._notesThreadView()} </div>
        </div>{" "}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { documentNotes, mentionUsers } = state.NotesStore;
  const {
    document: { id: docID, status, docType },
    activeComponentMeta: { tableCellId },
    components = {},
  } = state.DocumentStore;
  return {
    documentNotes,
    docID,
    mentionUsers,
    status,
    docType,
    tableCellId,
    components,
  };
};

const mapDispatchToProps = {
  getAllDocNotes,
  acceptRejectSectionChanges,
  getDocNotes: (docID, docType) => getNotesByDocID(docID, docType),
  addNewNote: note => addNote(note),
  updateNotesList: noteList => updateNotes(noteList),
  createNote: note => postNewNote(note),
  createSharedDocumentNote: note => createSharedDocumentNote(note),
  editNoteByID: (noteID, data) => editNote(noteID, data),
  deleteNoteByID: noteID => deleteNote(noteID),
  uploadNoteAttachment: formData => uploadAttachment(formData),
  fetchAllUsersForMentions,
  updateDocumentClickedComponentID,
  initEditorState,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Notes);



// WEBPACK FOOTER //
// ./src/components/Notes/Notes.js